<div class="esign-disclosures" *transloco="let t">
	<div *ngIf="!esignEnabled">
		<op-masthead
			><b class="client-name"> {{ t('ESIGN_DISCLOSURE.title', { clientName: clientName }) }} </b></op-masthead
		>
		<p class="op-mb-20">
			{{ t('ESIGN_DISCLOSURE.msgInitial') }}
		</p>
		<op-content-container class="content">
			<form [formGroup]="formGroup" (ngSubmit)="onSubmit(formGroup.value)">
				<mat-checkbox formControlName="accept" id="accept" color="primary">
					{{ t('ESIGN_DISCLOSURE.acceptInitial') }}
					<a class="text-decoration-underline">
						<b>{{ t('ESIGN_DISCLOSURE.disclosures') }}</b>
					</a></mat-checkbox
				>
				<div class="left">
					<button
						mat-flat-button
						color="primary"
						[disabled]="!formGroup.value.accept"
						name="findLetterBtn"
						id="submitBtn"
						type="submit"
					>
						{{ t('ESIGN_DISCLOSURE.submit') }}
					</button>
				</div>
			</form>
		</op-content-container>

		<div class="op-mt-20">
			<p></p>
		</div>
	</div>

	<div *ngIf="esignEnabled">
		<op-masthead
			><b class="client-name"> {{ t('ESIGN_DISCLOSURE.title', { clientName: clientName }) }} </b></op-masthead
		>
		<p class="op-mb-20">
			{{ t('ESIGN_DISCLOSURE.msg') }}
		</p>
		<op-content-container class="content">
			<form [formGroup]="formGroup" (ngSubmit)="onSubmit(formGroup.value)">
				<mat-checkbox formControlName="accept" id="accept" color="primary">
					<span class="esign-accept" *ngIf="originator === 'METABANK'">{{ t('ESIGN_DISCLOSURE.acceptMeta') }}</span>
					<span class="esign-accept" *ngIf="originator === 'OPORTUN'">{{ t('ESIGN_DISCLOSURE.acceptOportun') }}</span>
					<div class="read-alouds-container">
						<a [href]="esignLink" target="_blank" class="read-aloud" id="esignDisclosureLink" rel="noopener">{{
							t('ESIGN_DISCLOSURE.esignActDisclosure')
						}}</a>

						<a
							class="read-aloud"
							[routerLink]="['/caaDisclosure']"
							title="esign-disclosures"
							aria-label="esign-disclosures"
							id="footerAccessibilityLink"
							>{{ 'ESIGN_DISCLOSURE.caaDisclosure' | transloco }}</a
						>
						<a
							*ngIf="applicantIndex === 0"
							class="read-aloud"
							[routerLink]="['/bankAccountsDisclosure']"
							title="esign-disclosures"
							aria-label="esign-disclosures"
							id="footerAccessibilityLink"
							>{{ 'ESIGN_DISCLOSURE.bankAccountDisclosure' | transloco }}</a
						>
						<a
							class="read-aloud"
							[routerLink]="['/documentDisclosure']"
							title="esign-disclosures"
							aria-label="esign-disclosures"
							id="footerAccessibilityLink"
							>{{ 'ESIGN_DISCLOSURE.supplierDocumentsDisclosure' | transloco }}</a
						>
					</div>
				</mat-checkbox>
				<div class="left">
					<button
						mat-flat-button
						color="primary"
						[disabled]="!formGroup.value.accept"
						name="findLetterBtn"
						id="submitBtn"
						type="submit"
					>
						{{ t('ESIGN_DISCLOSURE.agree') }}
					</button>
				</div>
			</form>
		</op-content-container>

		<div class="op-mt-20">
			<p></p>
		</div>
	</div>
</div>
